
import { WorldCountry } from '../types';
import { canadaExpanded } from './canadaExpansion';

export const northAmericaExpansion: WorldCountry[] = [
  canadaExpanded,
  
  // Guatemala expandida
  {
    code: 'GT',
    name: 'Guatemala',
    slug: 'guatemala',
    population: 17263000,
    topCities: [
      { name: 'Guatemala City', slug: 'guatemala-city', population: 2934841 },
      { name: 'Mixco', slug: 'mixco', population: 473080 },
      { name: 'Villa Nueva', slug: 'villa-nueva', population: 618397 },
      { name: 'Petapa', slug: 'petapa', population: 141455 },
      { name: 'San Juan Sacatepéquez', slug: 'san-juan-sacatepequez', population: 152583 },
      { name: 'Quetzaltenango', slug: 'quetzaltenango', population: 120512 },
      { name: 'Villa Canales', slug: 'villa-canales', population: 122194 },
      { name: 'Escuintla', slug: 'escuintla', population: 103165 },
      { name: 'Chinautla', slug: 'chinautla', population: 97172 },
      { name: 'Chimaltenango', slug: 'chimaltenango', population: 96985 },
      
      // Expanded to 100 cities
      { name: 'Amatitlán', slug: 'amatitlan', population: 114516 },
      { name: 'Totonicapán', slug: 'totonicapan', population: 98173 },
      { name: 'Santa Catarina Pinula', slug: 'santa-catarina-pinula', population: 85509 },
      { name: 'Cobán', slug: 'coban', population: 86000 },
      { name: 'Puerto Barrios', slug: 'puerto-barrios', population: 39000 },
      { name: 'San Marcos', slug: 'san-marcos', population: 47896 },
      { name: 'Huehuetenango', slug: 'huehuetenango', population: 79426 },
      { name: 'Jalapa', slug: 'jalapa', population: 35000 },
      { name: 'Jutiapa', slug: 'jutiapa', population: 38000 },
      { name: 'Sololá', slug: 'solola', population: 25000 },
      { name: 'Mazatenango', slug: 'mazatenango', population: 44132 },
      { name: 'Retalhuleu', slug: 'retalhuleu', population: 36656 },
      { name: 'El Progreso', slug: 'el-progreso', population: 20000 },
      { name: 'Zacapa', slug: 'zacapa', population: 42000 },
      { name: 'Chiquimula', slug: 'chiquimula', population: 41000 },
      { name: 'Flores', slug: 'flores', population: 13700 },
      { name: 'Antigua Guatemala', slug: 'antigua-guatemala', population: 63685 },
      { name: 'San Pedro Ayampuc', slug: 'san-pedro-ayampuc', population: 38575 },
      { name: 'San José Pinula', slug: 'san-jose-pinula', population: 78000 },
      { name: 'Fraijanes', slug: 'fraijanes', population: 55270 },
      { name: 'Santa María de Jesús', slug: 'santa-maria-de-jesus', population: 15000 },
      { name: 'Palencia', slug: 'palencia', population: 65000 },
      { name: 'San Pedro Sacatepéquez', slug: 'san-pedro-sacatepequez', population: 25000 },
      { name: 'San Lucas Sacatepéquez', slug: 'san-lucas-sacatepequez', population: 30000 },
      { name: 'Santiago Sacatepéquez', slug: 'santiago-sacatepequez', population: 28000 },
      { name: 'Sumpango', slug: 'sumpango', population: 26000 },
      { name: 'Santo Domingo Xenacoj', slug: 'santo-domingo-xenacoj', population: 8000 },
      { name: 'San Raymundo', slug: 'san-raymundo', population: 20000 },
      { name: 'Chuarrancho', slug: 'chuarrancho', population: 12000 },
      { name: 'San Pedro Ayampuc', slug: 'san-pedro-ayampuc-2', population: 35000 },
      { name: 'Chinautla', slug: 'chinautla-2', population: 90000 },
      { name: 'San José del Golfo', slug: 'san-jose-del-golfo', population: 6000 },
      { name: 'Pachalum', slug: 'pachalum', population: 15000 },
      { name: 'San Martín Jilotepeque', slug: 'san-martin-jilotepeque', population: 18000 },
      { name: 'San Juan Comalapa', slug: 'san-juan-comalapa', population: 32000 },
      { name: 'Santa Apolonia', slug: 'santa-apolonia', population: 6000 },
      { name: 'Tecpán Guatemala', slug: 'tecpan-guatemala', population: 32000 },
      { name: 'Patzún', slug: 'patzun', population: 45000 },
      { name: 'Pochuta', slug: 'pochuta', population: 12000 },
      { name: 'Patzicía', slug: 'patzicia', population: 23000 },
      { name: 'Santa Cruz Balanyá', slug: 'santa-cruz-balanya', population: 5000 },
      { name: 'Acatenango', slug: 'acatenango', population: 18000 },
      { name: 'Yepocapa', slug: 'yepocapa', population: 32000 },
      { name: 'San Andrés Itzapa', slug: 'san-andres-itzapa', population: 25000 },
      { name: 'Parramos', slug: 'parramos', population: 8000 },
      { name: 'Zaragoza', slug: 'zaragoza', population: 15000 },
      { name: 'El Tejar', slug: 'el-tejar', population: 18000 },
      { name: 'Pastores', slug: 'pastores', population: 8000 },
      { name: 'Jocotenango', slug: 'jocotenango', population: 18000 },
      { name: 'San Bartolomé Milpas Altas', slug: 'san-bartolome-milpas-altas', population: 6000 },
      { name: 'San Lucas Tolimán', slug: 'san-lucas-toliman', population: 18000 },
      { name: 'Santa Catarina Ixtahuacán', slug: 'santa-catarina-ixtahuacan', population: 25000 },
      { name: 'Santa Clara La Laguna', slug: 'santa-clara-la-laguna', population: 4000 },
      { name: 'Concepción', slug: 'concepcion', population: 1600 },
      { name: 'San Andrés Semetabaj', slug: 'san-andres-semetabaj', population: 12000 },
      { name: 'Panajachel', slug: 'panajachel', population: 11500 },
      { name: 'Santa Catarina Palopó', slug: 'santa-catarina-palopo', population: 4000 },
      { name: 'San Antonio Palopó', slug: 'san-antonio-palopo', population: 9000 },
      { name: 'San Pedro La Laguna', slug: 'san-pedro-la-laguna', population: 11000 },
      { name: 'Santiago Atitlán', slug: 'santiago-atitlan', population: 32000 },
      { name: 'San Marcos La Laguna', slug: 'san-marcos-la-laguna', population: 1200 },
      { name: 'Chicacao', slug: 'chicacao', population: 50000 },
      { name: 'Pueblo Nuevo Tiquisate', slug: 'pueblo-nuevo-tiquisate', population: 15000 },
      { name: 'Nueva Concepción', slug: 'nueva-concepcion', population: 25000 },
      { name: 'Tiquisate', slug: 'tiquisate', population: 25000 },
      { name: 'Patulul', slug: 'patulul', population: 35000 },
      { name: 'Santa Bárbara', slug: 'santa-barbara', population: 18000 },
      { name: 'Cuyotenango', slug: 'cuyotenango', population: 28000 },
      { name: 'San Francisco Zapotitlán', slug: 'san-francisco-zapotitlan', population: 12000 },
      { name: 'San Bernardino', slug: 'san-bernardino', population: 6000 },
      { name: 'San José El Ídolo', slug: 'san-jose-el-idolo', population: 4000 },
      { name: 'Santo Domingo Suchitepéquez', slug: 'santo-domingo-suchitepequez', population: 15000 },
      { name: 'San Lorenzo', slug: 'san-lorenzo', population: 12000 },
      { name: 'Samayac', slug: 'samayac', population: 18000 },
      { name: 'San Pablo Jocopilas', slug: 'san-pablo-jocopilas', population: 8000 },
      { name: 'San Antonio Suchitepéquez', slug: 'san-antonio-suchitepequez', population: 35000 },
      { name: 'San Miguel Panán', slug: 'san-miguel-panan', population: 22000 },
      { name: 'San Gabriel', slug: 'san-gabriel', population: 10000 },
      { name: 'Chicacao', slug: 'chicacao-2', population: 30000 },
      { name: 'Río Bravo', slug: 'rio-bravo', population: 14000 },
      { name: 'San Juan Bautista', slug: 'san-juan-bautista', population: 9000 },
      { name: 'Zunilito', slug: 'zunilito', population: 13000 },
      { name: 'Pueblo Nuevo', slug: 'pueblo-nuevo', population: 8000 },
      { name: 'San José La Máquina', slug: 'san-jose-la-maquina', population: 15000 },
      { name: 'Sipacate', slug: 'sipacate', population: 7000 },
      { name: 'La Democracia', slug: 'la-democracia', population: 12000 },
      { name: 'Siquinalá', slug: 'siquinala', population: 15000 },
      { name: 'Masagua', slug: 'masagua', population: 25000 },
      { name: 'Santa Lucía Cotzumalguapa', slug: 'santa-lucia-cotzumalguapa', population: 28000 },
      { name: 'La Gomera', slug: 'la-gomera', population: 20000 },
      { name: 'Guanagazapa', slug: 'guanagazapa', population: 15000 },
      { name: 'San José', slug: 'san-jose', population: 6000 },
      { name: 'Iztapa', slug: 'iztapa', population: 8000 },
      { name: 'Palín', slug: 'palin', population: 25000 },
      { name: 'San Vicente Pacaya', slug: 'san-vicente-pacaya', population: 12000 },
      { name: 'Nueva Santa Rosa', slug: 'nueva-santa-rosa', population: 20000 },
      { name: 'Taxisco', slug: 'taxisco', population: 15000 },
      { name: 'Guazacapán', slug: 'guazacapan', population: 18000 },
      { name: 'Chiquimulilla', slug: 'chiquimulilla', population: 45000 },
      { name: 'Pasaco', slug: 'pasaco', population: 12000 },
      { name: 'Oratorio', slug: 'oratorio', population: 8000 },
      { name: 'San Rafael Las Flores', slug: 'san-rafael-las-flores', population: 9000 },
      { name: 'Santa Rosa de Lima', slug: 'santa-rosa-de-lima', population: 12000 },
      { name: 'Barberena', slug: 'barberena', population: 42000 },
      { name: 'Cuilapa', slug: 'cuilapa', population: 15000 },
      { name: 'Casillas', slug: 'casillas', population: 25000 }
    ]
  }
];
